import { useEffect, useState } from 'react';
import { DetailUser } from '@models/types/users.type';
import { useAtomValue } from 'jotai';
import { userDetailQueryAtom } from '@atom/globalQueryAtom';

export function useCanShowLeaderboard() {
  const [show, setShow] = useState(false);
  const userDetail = useAtomValue(userDetailQueryAtom);

  const range = (start: number, stop: number, step: number) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step,
    );
  const levelList = [...range(-4, 12, 1), 14];

  useEffect(() => {
    if (userDetail.data?.data) {
      const user: DetailUser = userDetail.data.data;
      if (
        levelList.findIndex(level => level == parseInt(user.system_level)) !==
        -1
      ) {
        setShow(true);
      }
    }
  }, [userDetail.data?.data]);

  return show;
}
